export default "__VITE_ASSET__DuzA8pbx__"